// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2Tuy4","content":"ManualTimeModal_content__3YBTt"};